<div class="page">
    <div class="page-header">
        <div class="header-left">
            <mat-icon class="back-icon" routerLink="/doctors">arrow_back</mat-icon>
            <h3>ORVOS HOZZÁADÁSA</h3>
        </div>
    </div>
    <p class="required-info">A * - al jelölt mezők kitöltése kötelező!</p>

    <div class="form-section">
        <form novalidate [formGroup]="doctorForm!">
            <div class="form-row">
                <label for="name">Orvos neve <span class="required">*</span></label>
                <div class="form-input">
                    <input formControlName="name" id="name" type="text" required [(ngModel)]="doctor.name" />
                </div>
            </div>

            <div class="form-row">
                <label for="reservationLink">Orvos foglalási linkje <span class="required">*</span></label>
                <div class="form-input">
                    <input formControlName="reservationLink" id="reservationLink" type="text" required
                        [(ngModel)]="doctor.reservationLink" />
                </div>
            </div>

            <div class="form-row">
                <label for="routerLink">Orvos url-e <span class="required">*</span></label>
                <div class="form-input">
                    <span class="hint">Pl.: dr_balo_timea</span>
                    <input formControlName="routerLink" id="routerLink" type="text" required
                        [(ngModel)]="doctor.routerLink" />
                </div>
            </div>

            <div class="form-row full-width">
                <label>Orvos bemutatkozó szövege <span class="required">*</span></label>
                <pf-fileexplorer />
                <div class="form-input">
                    <app-tinymcehtmleditor id="html" ngDefaultControl [html]="doctor.introduction!"
                        [htmlForm]="htmlForm" />
                </div>
            </div>
        </form>

        <div class="form-row">
            <label>Kép <span class="required">*</span> (.jpg vagy .png)</label>
            <div class="form-input file-row">
                <button type="button" class="btn btn-file" onclick="document.getElementById('fileCover').click()">
                    Kép kiválasztása
                </button>
                @if (uploadCoverFile) {
                <span>{{ fileCover?.name }}</span>
                }
                <mat-icon class="delete-icon" (click)="clearSelectedCoverFile()">delete_forever</mat-icon>
                <input #fileCoverInput id="fileCover" type="file" hidden (change)="onChange($event)" />
            </div>
        </div>
    </div>

    <div class="form-section">
        <h4 class="section-title">Orvos munkakörei <span class="required">*</span></h4>
        <mat-icon class="add-icon" routerLink="/addspeciality">add_circle</mat-icon>
        <div class="form-row">
            <div class="form-input checkbox-wrap">
                @for (speciality of specialityWithCheckedList; track speciality) {
                <section>
                    <mat-checkbox (click)="changeJobTitle(speciality)">
                        {{ speciality.speciality?.jobTitle }}
                    </mat-checkbox>
                </section>
                }
            </div>
        </div>
    </div>

    <div class="form-section">
        <h4 class="section-title">Konzultációs idő hozzáadása <span class="required">*</span></h4>
        <mat-icon class="add-icon" (click)="openAddConsultingHourDialog()">add_circle</mat-icon>

        @for (consultationHour of doctorConsultingHoursList; track consultationHour; let i = $index) {
        <div class="consulting-row" [ngStyle]="i % 2 === 0 ? { background: 'white' } : { background: '#efeff5' }">
            <div class="form-row no-border">
                <label>Konzultáció napja:</label>
                <div class="form-input"><span>{{ consultationHour.day }}</span></div>
            </div>
            <div class="form-row no-border">
                <label>Konzultáció kezdete:</label>
                <div class="form-input">
                    <span>{{ consultationHour.startTime !== null ? consultationHour.startTime : 'változó' }}</span>
                </div>
            </div>
            <div class="form-row no-border">
                <label>Konzultáció vége:</label>
                <div class="form-input">
                    <span>{{ consultationHour.endTime !== null ? consultationHour.endTime : 'változó' }}</span>
                </div>
                <mat-icon class="delete-icon" (click)="removeConsultingHour(i)">delete_forever</mat-icon>
            </div>
        </div>
        }

        <h4 class="section-title">SEO</h4>
        <pf-meta [isUpdate]="false" [urlPrefix]="doctorUrlPrefix" />
    </div>

    <div class="submit-row">
        <button class="btn btn-submit" [disabled]="!isFormValid" (click)="addDoctor()">
            ORVOS MENTÉSE
        </button>
    </div>
</div>